import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  createNote,
  updateNote,
  clearSubmitSiteError,
  selectSitesState,
} from '../../redux/slices/sitesSlice';
import ErrorBox from '../../components/ErrorBox';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { TextField, Button, InputAdornment, TableCell, TableRow, Table } from '@material-ui/core';
import { useFormStyles } from '../../styles/muiStyles';
import CommentIcon from '@material-ui/icons/Comment';
import React from 'react';
import { formatDate, formatDateTime } from '../../utils/helperFuncs';
import { format } from 'date-fns';

const validationSchema = yup.object({
  body: yup.string().required('Required'),
});

interface NoteFormProps {
  closeDialog?: () => void;
  siteId: string;
  contactId: number | undefined;
  date: string, // Date,// | string,
  isEditMode: boolean;
  currentBody?: string;
}

const NoteForm: React.FC<NoteFormProps> = ({
  closeDialog,
  isEditMode,
  siteId,
  contactId,
  date,
  currentBody,
}) => {
  const classes = useFormStyles();
  const dispatch = useDispatch();
  const { submitError, submitLoading } = useSelector(selectSitesState);
  let theDate: string
  if(date === null || date === undefined /*date === '' ||  date === " " || date === 'NULL'*/) {
    theDate = format(new Date(Date.now()), "yyyy-MM-dd'T'h':'mm")//new Date()
    console.log("Date was NULL ?NN??N : "+theDate)
  } else {
//    console.log("Date was NOTTTTTTTTTTTTTT NULL ?NN??N : "+date)
  }
  console.log("Date update DEBUG: ["+date+"]")
//  console.log("THE Date update DEBUG: "+theDate)

  if(date === null){
    console.log("ARG DATE is really NULL")
  }
  const { register, handleSubmit, errors } = useForm({
    mode: 'onChange',
    //resolver: yupResolver(validationSchema),
    defaultValues: {
      siteNote: currentBody || '',
      contactId: contactId,
      date_update: isEditMode ? date : new Date().toISOString().slice(0, 16),//format(new Date(date/*.split("T")[0]*/), "yyyy-MM-dd'T'h':'mm"), 
    },
  });
  console.log("BODY: "+currentBody)
  const onSubmit = handleSubmit((data) => {
    console.log("Submit called ... ?")
    isEditMode ?
      dispatch(updateNote(siteId, data, closeDialog))
    :  dispatch(createNote(siteId, data, closeDialog))
  });

  return (
    <div/* style={{ maxWidth: '100%', display: 'inline-flex' }}*/>
    <form
      onSubmit={onSubmit}
    >
    { isEditMode ?
    <TextField style={{ maxWidth: '19%', minWidth: '10%' }}// className={MoreClasses.dateInput}
        inputRef={register}
        //id="date_update"
        name="date_update"
        label={"Date"}
        type="datetime-local"
        variant="filled" 
        margin='normal'
//        defaultValue={!isEditMode && format(new Date(), "yyyy-MM-dd'T'h':'mm")}
//        defaultValue={date_update /*!== null ? format(new Date(currDate_end), "yyyy-MM-dd'T'h':'mm") : ''*/}
//        onChange={handleDateChg}
        InputLabelProps={{
            shrink: true,
        }}
        disabled={date !== "" ? true : false}
        />
    : <TextField style={{ maxWidth: '19%' }}// className={MoreClasses.dateInput}
    inputRef={register}
    //id="date_update"
    name="date_update"
    label={"Date"}
    type="datetime-local"
    variant="filled" 
    margin='normal'
//    defaultValue={//new Date().toISOString().slice(0, 16)}
//        onChange={handleDateChg}
    InputLabelProps={{
        shrink: true,
    }}
    />}
    <TextField style={{ maxWidth: '75%' }}
      margin='normal'
      multiline
      rows={1}
      rowsMax={4}
      inputRef={register}
      name="siteNote"
      placeholder="Entrez une note..."
      required
      fullWidth
      type="text"
      label="Note"
      variant="outlined"
      error={'siteNote' in errors}
      helperText={'siteNote' in errors ? errors.siteNote?.message : ''}
      InputProps={{
          startAdornment: (
          <InputAdornment position="start">
              <CommentIcon color="primary" />
          </InputAdornment>
          ),
      }}
    />
    <TextField
      inputRef={register}
      name="contactId"
      value={contactId}
      hidden
      style={{display: 'none'}}
    />
    <Button style={{ maxWidth: '12%' }}
      size="large"
      color={ isEditMode ? "primary" : "secondary" }
      variant="contained"
      fullWidth
      className={classes.submitBtn}
      type="submit"
      disabled={submitLoading}
      >
      {isEditMode ? 'MàJ' : 'Ajouter'}
    </Button>
    {submitError && (
    <ErrorBox
      errorMsg={submitError}
      clearErrorMsg={() => dispatch(clearSubmitSiteError())}
    />
    )}
    </form>
    </div>
  );
};

export default NoteForm;